import { render, staticRenderFns } from "./SqNoData.vue?vue&type=template&id=0e684026"
import script from "./SqNoData.vue?vue&type=script&lang=ts"
export * from "./SqNoData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports